var App = App || {};

App.WidgetMastheadPromos = (function ($) {
    'use strict';

    function Init(widget) {
        Carousel(widget);
    }

    function Animate(widget) {
        const animate = widget.find(".component-masthead__promos");
        animate.ZagScrollAnimate({
            targets: [
                { selector: ".reusable-mastheadPromo", type: "animate__fadeInUp", stagger: 200 }
            ]
        });
    }

    function Carousel(widget) {

        const carousel = widget.find(".splide");

        if (carousel.length) {

            const options = {
                type: 'slide',
                rewind: true,
                speed: 500,
                arrows: true,
                pagination: false,
                autoWidth: true
            }

            const splide = new Splide(carousel[0], options);

            splide.on('overflow', function (isOverflow) {
                splide.go(0);

                splide.options = {
                    arrows: isOverflow,
                    drag: isOverflow,
                    clones: isOverflow ? undefined : 0,
                    label: "Masthead Promotions Carousel"
                };

                carousel.toggleClass("is-carousel", isOverflow);
            });

            splide.on('mounted', function () { Animate(widget); });
            splide.mount();
        }
    }

    return {
        Init: Init
    };

})(jQuery);

App.WidgetMastheadFeatures = (function ($) {
    'use strict';

    function Init(widget) {
        Animate(widget);
    }

    function Animate(widget) {
        const animate = widget.find(".component-masthead__features");
        animate.ZagScrollAnimate({
            targets: [
                { selector: ".reusable-mastheadFeature", type: "animate__fadeInUp", stagger: 200 }
            ]
        });
    }

    return {
        Init: Init
    };

})(jQuery);

App.WidgetMastheadDefault = (function ($) {
    'use strict';

    function Init(widget) {
        Animate(widget);
    }

    function Animate(widget) {
        const animate = widget;
        animate.ZagScrollAnimate({
            targets: [
                { selector: ".component-masthead__image", type: "animate__fadeInUp" }
            ]
        });
    }

    return {
        Init: Init
    };

})(jQuery);